import { EWidgetResultStatus, IWidgetResultSuccess } from '../../types/api';
import { EPaymentProvider } from '../../types/redux/paymentMethods';

interface IParams {
  paymentId: string;
  transactionId: string | undefined;
  provider: EPaymentProvider;
}

export const getResultSuccess = (params: IParams): IWidgetResultSuccess => {
  const { paymentId, transactionId, provider } = params;

  return {
    status: EWidgetResultStatus.Success,
    paymentId,
    transactionId,
    provider,
  };
};
